export default __webpack_public_path__ + "static/img-dappradar-e3a73e6db40321de8eed5a28cf35f107.png";